import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import { post, normalPost } from "../../lib/Fetching";
import IndividualScheduleForm from "./IndividualScheduleForm";
import styled, { css } from "styled-components";
import { removeProducts } from "../../lib/ProductActions";

const ReplaceForm = styled.div`
  padding: 40px;
  border: 1px solid #ddd;
  margin-bottom: 20px;
  margin-top: 20px;
  background-color: white;
`;

export default class SchedulesActionBar extends React.Component {
  state = {
    showReplaceForm: false,
    loading: false,
  };

  toggleReplaceForm = () =>
    this.setState((state) => ({
      showReplaceForm: !state.showReplaceForm,
    }));

  completeAction = (json) => {
    this.setState({ loading: false });
    if (json.errors) {
      alert(json.errors);
      return;
    }
    this.setState({
      showReplaceForm: false,
    });
    this.props.reloadProducts();
  };

  showError = (e) => {
    this.setState({ loading: false });
    alert(e);
  };

  removeProducts = () => {
    const { productIds } = this.props;
    removeProducts(productIds, this.completeAction);
  };

  removeSchedules = () => {
    const { schedules, reloadProducts } = this.props;
    post(
      "/products/product_test_schedules/destroy.json",
      {
        schedules: schedules.map((s) => ({
          product_id: s.product_id,
          client_suite_id: s.client_suite_id,
          client_specification_id: s.client_specification_id,
          sample_information_id: s.sample_information_id,
        })),
      },
      "DELETE"
    )
      .then(this.completeAction)
      .catch(this.showError);
  };

  copySchedulesToProducts = () => {
    const { schedules, productIds } = this.props;
    this.setState({ loading: true });
    post("/products/product_test_schedules/copy.json", {
      product_ids: productIds,
      schedules: schedules.map((s) => ({
        client_suite_id: s.client_suite_id,
        client_specification_id: s.client_specification_id,
        sample_information_id: s.sample_information_id,
      })),
    })
      .then(this.completeAction)
      .catch(this.showError);
  };

  editDefaultAttributes = () => {
    const { productIds, company_id } = this.props;
    normalPost(
      "/products/default_product_list_items/edit",
      {
        ids: productIds,
        company_id,
      },
      false,
      "GET"
    );
  };

  deleteSchedulesFromMultipleProducts = () => {
    const { schedules, productIds } = this.props;
    post(
      "/products/product_test_schedules/delete_from_multiple_products.json",
      {
        product_ids: productIds,
        schedules: schedules.map((s) => ({
          client_suite_id: s.client_suite_id,
          client_specification_id: s.client_specification_id,
          sample_information_id: s.sample_information_id,
        })),
      },
      "DELETE"
    )
      .then(this.completeAction)
      .catch(this.showError);
  };

  replaceSchedulesAcrossProducts = () => {
    const { productIds, schedules } = this.props;
    if (schedules.length !== 1) return null;
    const schedule = schedules[0];

    if (productIds.length == 0) {
      alert("You haven't selected any products");
      return;
    }
    if (!this.scheduleForm.isValid()) {
      alert("The schedule is not valid");
      return;
    }
    post("/products/product_test_schedules/replace.json", {
      product_ids: productIds,
      replace: {
        client_suite_id: schedule.client_suite_id,
        client_specification_id: schedule.client_specification_id,
        sample_information_id: schedule.sample_information_id,
      },
      with: this.scheduleForm.scheduleParameters(),
    })
      .then(this.completeAction)
      .catch(this.showError);
  };

  renderReplaceScheduleForm = () => {
    const { company_id, schedules, productIds } = this.props;
    if (schedules.length !== 1) return null;
    const schedule = schedules[0];

    return (
      <ReplaceForm>
        <h4> Replacing Schedule Across Products </h4>

        <p> Replacing Schedule: </p>

        <p>
          <strong>
            {" "}
            {schedule.sample_information_name}/ {schedule.client_suite_name} /{" "}
            {schedule.client_specification_name || "No Specification"}{" "}
          </strong>{" "}
        </p>

        <p> With Schedule: </p>

        <IndividualScheduleForm
          ref={(ref) => (this.scheduleForm = ref)}
          company_id={company_id}
        />

        <p
          style={{
            marginTop: 10,
          }}
        >
          {" "}
          in {productIds.length} selected products .<br />
          This will also replace the testing in any lists/shopping-lists the client has created
          for themselves.
        </p>

        <Button
          onClick={this.replaceSchedulesAcrossProducts}
          primary
          title="Replace Schedules in Selected Products"
        />
      </ReplaceForm>
    );
  };

  render() {
    const { schedules, productIds } = this.props;
    const { showReplaceForm, loading } = this.state;
    if (loading) {
      return (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin" /> Please wait while your action is completed..
        </div>
      );
    }
    return (
      <div>
        <div
          className="btn-toolbar"
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            marginBottom: 10,
          }}
        >
          <div className="btn-group pull-left">
            <Button
              onClick={this.removeProducts}
              tiny
              deleting
              title="Remove Products"
              disabled={productIds.length == 0}
            />{" "}
          </div>{" "}
          <div className="btn-group pull-left">
            <Button
              onClick={this.editDefaultAttributes}
              tiny
              title="Edit Default Attributes"
              disabled={productIds.length == 0}
            />
          </div>
          <div className="btn-group pull-right">
            <Button
              onClick={this.removeSchedules}
              tiny
              deleting
              title="Remove Schedules"
              disabled={schedules.length == 0}
            />{" "}
          </div>{" "}
          <div className="btn-group pull-right">
            <Button
              onClick={this.deleteSchedulesFromMultipleProducts}
              tiny
              deleting
              title="Remove Schedules From Selected Products"
              disabled={schedules.length == 0 || productIds.length == 0}
            />{" "}
          </div>{" "}
          <div className="btn-group pull-right">
            <Button
              onClick={this.copySchedulesToProducts}
              tiny
              primary
              title="Copy To Selected Products"
              disabled={schedules.length == 0 || productIds.length == 0}
            />{" "}
          </div>{" "}
          <div className="btn-group pull-right">
            <Button
              onClick={this.toggleReplaceForm}
              tiny
              primary
              title="Replace Schedule"
              disabled={schedules.length !== 1}
            />{" "}
          </div>{" "}
        </div>{" "}
        {showReplaceForm && this.renderReplaceScheduleForm()}{" "}
      </div>
    );
  }
}

SchedulesActionBar.propTypes = {
  productIds: PropTypes.array,
  schedules: PropTypes.array,
  reloadProducts: PropTypes.func,
  company_id: PropTypes.number,
};
